import clsx from "clsx";
import {
  gradientRowBgClass,
  shadowAndBorderClass,
} from "screens/Dashboard/utils/classes";
import {
  AnimatedGradientBorder,
  GlowCard,
} from "screens/Landing/components/shared";
import ReferralsIcon from "assets/svgComponents/referralsPage/ReferralsIcon";
import { useUserStore } from "store/user";
import usdtIcon from "../../../assets/icons/usdtIcon.png";
import { ClaimButton } from "./ClaimModal";
import { useTranslation } from "react-i18next";
import { referralRewardMultiplicator } from "constants/api";

const referralData = {
  totalEarnings: "12,093.00",
  referrals: {
    count: 25,
    description: "People who purchased $ATTS using your link",
  },
  vested: {
    amount: "1,923.09",
    description: "Total sum of purchases in USDT by referrals",
  },
  claimable: {
    amount: "5,233.00",
  },
  totalClaimed: "12,093.00",
};

export function YourReferralEarnings() {
  const { user } = useUserStore();
  const { t } = useTranslation();

  const totalEarnings =
    (user?.referralEarningUsd ?? 0) +
    (user?.requestedEarningAmount ?? 0) +
    (user?.claimedEarningAmount ?? 0);

  return (
    <AnimatedGradientBorder className="rounded-[28px] max-lg:rounded-[24px] max-lg:w-full shrink-0 lg:w-[445px]  h-fit">
      <GlowCard
        className={clsx(
          "flex flex-col max-lg:w-full rounded-[28px] max-lg:rounded-[24px] max-lg:before:!rounded-[24px] before:!rounded-[28px] bg-[#111111] p-[12px] max-lg:p-[12px] h-fit",
        )}
      >
        <div
          className={clsx(
            "flex max-lg:mb-[16px] items-center rounded-[16px] before:!rounded-[16px] max-lg:rounded-[12px] max-lg:before:!rounded-[12px] max-lg:py-[8px] max-lg:px-[13px] lg:p-[8px] lg:pl-[16px]",
            gradientRowBgClass,
          )}
        >
          <h2 className="text-[24px] max-lg:text-20m font-luxora-medium leading-[110%] text-white">
            {t("Your referral Earnings")}
          </h2>
        </div>

        <div className="flex-grow flex max-lg:gap-[8px] flex-col justify-between">
          <div className="grid grid-cols-2 max-lg:grid-cols-1 max-lg:gap-[8px] gap-[8px] lg:mt-[16px]">
            <div
              className={clsx(
                "flex rounded-[16px] max-lg:rounded-[12px] gap-[8px] max-lg:gap-[8px] before:!rounded-[16px] max-lg:before:!rounded-[12px] bg-[#161616] p-[8px] max-lg:p-[8px] lg:h-[101px]",
                shadowAndBorderClass,
              )}
            >
              <div
                className={clsx(
                  "lg:min-w-[28px] lg:min-h-[28px] w-[28px] h-[28px] max-lg:w-[28px] max-lg:h-[28px] bg-[#252525] flex items-center justify-center max-lg:rounded-[8px] rounded-[8px] ",
                  shadowAndBorderClass,
                )}
              >
                <ReferralsIcon className="max-lg:h-[19px] max-lg:w-[19px]" />
              </div>
              <div className="flex flex-col gap-[4px]">
                {" "}
                <div className="flex items-center gap-[8px] max-lg:mb-[4px]">
                  <h3 className="text-[14px] max-lg:text-16m font-luxora-regular leading-[1.2] text-white">
                    {t("Referrals")}
                  </h3>
                </div>
                <p className="text-[12px] max-lg:mb-[8px] max-lg:text-12m font-luxora-regular leading-[110%] mb-[4px] text-white/40">
                  {t("referralData.referrals.description")}
                </p>
                <div className="text-[24px] max-lg:text-24m font-luxora-medium  leading-[110%] text-white">
                  {user.referrals_count ? user.referrals_count : 0}
                </div>
              </div>
            </div>

            <div
              className={clsx(
                "flex rounded-[16px] max-lg:rounded-[12px] gap-[8px] max-lg:gap-[8px] before:!rounded-[16px] max-lg:before:!rounded-[12px] bg-[#161616] p-[8px] max-lg:p-[8px] lg:h-[101px]",
                shadowAndBorderClass,
              )}
            >
              <div
                className={clsx(
                  "lg:min-w-[28px] lg:min-h-[28px] w-[28px] h-[28px] max-lg:w-[28px] max-lg:h-[28px] bg-[#252525] flex items-center justify-center max-lg:rounded-[8px] rounded-[8px] ",
                  shadowAndBorderClass,
                )}
              >
                <img
                  src={usdtIcon}
                  className="w-[28px] h-[28px] rounded-[8px] min-w-[28px] min-h-[28px]"
                  alt=""
                />
              </div>
              <div className="flex flex-col gap-[4px]">
                {" "}
                <div className="flex items-center gap-[8px] max-lg:mb-[4px]">
                  <h3 className="text-[14px] max-lg:text-16m font-luxora-regular leading-[1.2] text-white">
                    {t("Referral Purchases")}
                  </h3>
                </div>
                <p className="text-[12px] max-lg:mb-[8px] font-[400] max-lg:text-12m font-luxora-regular leading-[110%] mb-[4px] text-white/40">
                  {t("referralData.vested.description")}
                </p>
                <div className="text-[24px] max-lg:text-24m font-luxora-medium  leading-[110%] text-white">
                  {totalEarnings
                    ? (
                        totalEarnings * Number(referralRewardMultiplicator)
                      ).toFixed(2)
                    : 0}
                </div>
              </div>
            </div>
          </div>

          <div
            className="text-16 font-luxora-regular leading-[110%] max-lg:p-[12px] max-lg:rounded-[12px] max-lg:text-14m p-[12px] border-[2px]  text-left
         rounded-[16px] border-white/[0.06] text-white/40 max-lg:my-[12px] my-[16px]"
          >
            {t(
              "Your Claimed Earnings would be distributed in USDT BNB Chain to your connected wallet within 24h",
            )}
          </div>

          <ClaimButton />

          <div
            className="flex text-[16px] gap-[8px] items-center max-lg:p-[8px] max-lg:pl-[16px] justify-between font-[400] leading-[110%] lg:px-[12px] lg:py-[8px] border-[2px] text-left
         rounded-[16px] max-lg:rounded-[12px] max-lg:before:!rounded-[12px] border-white/[0.06] text-white/40 lg:mt-[8px] min-w-0"
          >
            <div className="min-w-0 flex-1 pr-[8px] text-16 max-lg:text-16m font-luxora-medium leading-[1.2] text-white break-words">
              {t("transactionStatus.requested")}
            </div>
            <div
              className={clsx(
                "flex shrink-0 items-center max-lg:gap-[8px] p-[4px] gap-[5.5px] max-lg:p-[5px] max-lg:pr-[8px] text-[18px] bg-[transparent] font-[500] leading-[110%] text-white",
              )}
            >
              <div
                className={clsx(
                  "w-[23px] h-[23px] max-lg:w-[24px] max-lg:h-[24px] bg-[#252525] flex items-center justify-center rounded-full ",
                  shadowAndBorderClass,
                )}
              >
                <img
                  src={usdtIcon}
                  className="w-[23px] h-[23px] max-lg:w-[24px] max-lg:h-[24px] rounded-[8px]"
                  alt=""
                />
              </div>
              <div className="text-[14px] max-lg:text-14m font-luxora-regular text-white leading-[110%]">
                {(user?.requestedEarningAmount || 0).toFixed(2)}{" "}
                <span className="text-[14px] max-lg:text-14m  text-white/40 leading-[110%]">
                  {t("USDT")}
                </span>
              </div>
            </div>
          </div>
          <div
            className="flex text-16 gap-[8px] items-center max-lg:p-[8px] max-lg:pl-[16px] justify-between font-[400] leading-[110%] lg:px-[12px] lg:py-[8px] border-[2px] text-left
         rounded-[16px] max-lg:rounded-[12px] max-lg:before:!rounded-[12px] border-white/[0.06] text-white/40 lg:mt-[8px] min-w-0"
          >
            <div className="min-w-0 flex-1 pr-[8px] text-16 max-lg:text-16m font-luxora-medium leading-[1.2] text-white break-words">
              {t("Total Claimed")}
            </div>
            <div
              className={clsx(
                "flex shrink-0 items-center max-lg:gap-[8px] p-[4px] gap-[5.5px] max-lg:p-[5px] max-lg:pr-[8px] text-[18px] bg-[transparent] font-[500] leading-[110%] text-white",
              )}
            >
              <div
                className={clsx(
                  "w-[23px] h-[23px] max-lg:w-[24px] max-lg:h-[24px] bg-[#252525] flex items-center justify-center rounded-full ",
                  shadowAndBorderClass,
                )}
              >
                <img
                  src={usdtIcon}
                  className="w-[23px] h-[23px] max-lg:w-[24px] max-lg:h-[24px] rounded-[8px]"
                  alt=""
                />
              </div>
              <div className="text-[14px] max-lg:text-14m font-luxora-regular text-white leading-[110%]">
                {(user?.claimedEarningAmount || 0).toFixed(2)}{" "}
                <span className="text-[14px] max-lg:text-14m  text-white/40 leading-[110%]">
                  {t("USDT")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </GlowCard>
    </AnimatedGradientBorder>
  );
}
